import { validatorByIconTheme } from './../../utils/validator';
import { computed, defineComponent, onBeforeUnmount, ref, watch } from 'vue';
import TIcon from './../t-icon/index';
export default defineComponent({
    name: 'TModal',
    components: { TIcon },
    props: {
        modelValue: { type: Boolean, default: false },
        title: { type: String, default: '' },
        iconName: { type: String, default: '' },
        content: { type: [String, Array], default: '' },
        richText: { type: String, default: '' },
        footer: { type: Boolean, default: true },
        isNeedClose: { type: Boolean, default: true },
        isNeedCloseCancel: { type: Boolean, default: true },
        cancelText: { type: String, default: '' },
        confirmText: { type: String, default: '' },
        iconTheme: {
            type: String,
            default: 'default',
            validator: (value) => validatorByIconTheme(value),
        },
        align: {
            type: String,
            default: 'center',
            validator: (value) => ['center', 'right'].includes(value),
        },
        size: {
            type: String,
            default: 'medium',
            validator: (value) => ['medium', 'large'].includes(value),
        },
        theme: {
            type: String,
            default: 'default',
            validator: (value) => ['default', 'error', 'success'].indexOf(value) !== -1,
        },
    },
    emits: ['update:modelValue', 'close', 'cancel', 'confirm'],
    setup(props, context) {
        /** 组件的className前辍 */
        const prefixCls = ref('t-modal');
        /** 模板依赖的className */
        const getClasses = computed(() => {
            return {
                wrap: [prefixCls.value, `${prefixCls.value}__${props.theme}`],
                mask: [`${prefixCls.value}-mask`],
                inner: [`${prefixCls.value}-inner`, `${prefixCls.value}-inner__${props.size}`],
                header: [`${prefixCls.value}-hd`],
                body: [`${prefixCls.value}-bd`],
                footer: [`${prefixCls.value}-ft`, props.size === 'large' && `${prefixCls.value}-ft__large`],
                title: [`${prefixCls.value}-title`, `${prefixCls.value}-align__${props.align}`],
                icon: [`${prefixCls.value}-icon`],
                description: [
                    `${prefixCls.value}-desc`,
                    !props.title && props.size !== 'large' && `${prefixCls.value}-desc__large`,
                    `${prefixCls.value}-align__${props.align}`,
                ],
                close: [`${prefixCls.value}-close`],
                smallBtnCancel: [`${prefixCls.value}-btn`, `${prefixCls.value}-btn-sm`, `${prefixCls.value}-btn-sm__cancel`],
                smallBtnConfirm: [`${prefixCls.value}-btn`, `${prefixCls.value}-btn-sm`, `${prefixCls.value}-btn-sm__confirm`],
                largeBtnCancel: [`${prefixCls.value}-btn`, `${prefixCls.value}-btn-lg`, `${prefixCls.value}-btn-lg__cancel`],
                largeBtnConfirm: [`${prefixCls.value}-btn`, `${prefixCls.value}-btn-lg`, `${prefixCls.value}-btn-lg__confirm`],
                btnGroup: [`${prefixCls.value}-btn-group`],
                confirmText: [`${prefixCls.value}-btn-txt`, `${prefixCls.value}-btn__confirm`],
                cancelText: [`${prefixCls.value}-btn-txt`, `${prefixCls.value}-btn__cancel`],
            };
        });
        const isString = computed(() => typeof props.content === 'string');
        const getContent = computed(() => {
            if (props.content && typeof props.content === 'string') {
                return props.content.split('\\n');
            }
            return props.content;
        });
        const show = () => context.emit('update:modelValue', true);
        const hide = () => context.emit('update:modelValue', false);
        const onTapByClose = (event) => {
            hide();
            context.emit('close', event);
        };
        const onTapByCancel = (event) => {
            if (props.isNeedCloseCancel) {
                hide();
            }
            context.emit('cancel', event);
        };
        const onTapByConfirm = (event) => {
            if (props.isNeedClose) {
                hide();
            }
            context.emit('confirm', event);
        };
        // 监听modelValue, 做组修的内部的显示、隐藏逻辑
        const stopWatch = watch(() => props.modelValue, newValue => {
            newValue ? show() : hide();
        });
        onBeforeUnmount(() => {
            hide();
            stopWatch();
        });
        return {
            prefixCls,
            isString,
            getContent,
            getClasses,
            show,
            hide,
            onTapByClose,
            onTapByCancel,
            onTapByConfirm,
        };
    },
});
